export enum eRoles {
  ADMIN = 'ADMIN',
  EXHIBITOR = 'EXHIBITOR',
  MODERATOR = 'MODERATOR',
  SUPER_ADMIN = 'SUPER_ADMIN',
}
